import { useQuery } from '@tanstack/react-query';
import { referralService } from '@services';
import type { Friend } from '@types';

export const REFERRAL_REFEREES_QUERY_KEY = ['referral', 'referees'] as const;

export const useReferralReferees = () => {
  const {
    data: referees = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: REFERRAL_REFEREES_QUERY_KEY,
    queryFn: async () => {
      const data = await referralService.getRefereesBonusRewards();

      const mappedReferees: Friend[] = data.map((item) => ({
        ...item,
        joinedAt: new Date().toISOString(),
      }));

      return mappedReferees;
    },
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
  });

  return {
    referees,
    isLoading,
    error,
  };
};
